<template>
  <div id="program-items" class="clearfix flex items-center">
    <div style="width: 100%">
      <div v-for="(programItem, index) in getProgramItems()" class="program-item p2 md-p4" :key="index">
        <a v-if="typeof (programItem.Link) !== 'undefined'" :href="programItem.Link" target="_blank">
          <div class="flex justify-between relative">
            <div class="flex-grow">
              <h3 v-if="typeof (programItem.Heading) !== 'undefined'" class="m0 col-7">{{ programItem.Heading }}</h3>
              <h3 v-else class="m0">▓▓▓▒▒▒░░░</h3>
              <div class="program-description pl3 col-11">{{ programItem.Description}}</div>
            </div>
            <div class="link-arrow absolute"><img src="@/assets/icon-arrow.svg" /></div>
          </div>
        </a>
        <div v-else class="flex justify-between relative">
          <div class="flex-grow">
            <h3 v-if="typeof (programItem.Heading) !== 'undefined'" class="m0 c0l-7">{{ programItem.Heading }}</h3>
            <h3 v-else class="m0">▓▓▓▒▒▒░░░</h3>
            <div class="program-description pl3 col-11">{{ programItem.Description}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {

  name: 'ProgramItems',
  computed: {
    ...mapState([
      'programItems'
    ])
  },
  methods: {
    getProgramItems: function () {
      let regularProgramItems = this.programItems.filter(item => item.Featured !== true).slice(0, 6)

      if (regularProgramItems.length > 0) {
        return regularProgramItems
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>
  #program-items {
    background: rgb(45,45,255);
    line-height: 1.2;
    min-height: 100vh;
    font-size: var(--fs-m);
    width: 100%;

    .program-item {
      width: 100%;
      /*border-bottom: 4px solid rgb(200,200,255);*/
      color: rgb(200,200,255);
      margin: 0;
      border-bottom: 1px solid rgb(200,200,255);

      &:last-child {
        border-bottom: 0;
      }

      a, a:hover {
        color: rgb(200,200,255);
        text-decoration: none;
      }

      &:hover {
        .link-arrow {
          top: -0.5em;
          right: -0.5em;
        }
      }

      .link-arrow {
        top: 0;
        right: 0;
        transition: all 1s ease-out;
      }
    }
  }
</style>
